import { HttpInterceptorFn } from '@angular/common/http';
import { acceptLanguageInterceptor } from './accept-language.interceptor';
import { apiErrorInterceptor } from './api-error.interceptor';
import { apiPrefixInterceptor } from './api-prefix.interceptor';
import { apiTokenInterceptor } from './api-token.interceptor';
import { apiTokenRefreshInterceptor } from './api-token-refresh.interceptor';
import { formLocalesInterceptor } from './form-locales.interceptor';

export { acceptLanguageInterceptor, apiErrorInterceptor, apiPrefixInterceptor, apiTokenInterceptor, apiTokenRefreshInterceptor, formLocalesInterceptor };

/**
 * Functional interceptors in their fixed registration order, for
 * `provideHttpClient(withInterceptors([...CORE_INTERCEPTORS]))`.
 *
 * Order rationale (request flows top→down; responses bubble back up→down,
 * i.e. the last entry's response logic runs innermost):
 *
 *  1. apiToken          — request: sets `withCredentials`
 *  2. apiPrefix         — request: rewrites the URL
 *  3. apiError          — response: outermost error reporter (ignores 401 — left to refresh)
 *  4. apiTokenRefresh   — response: 401 → refresh + replay; inner to `apiError` so it
 *                         handles 401 before the error reporter sees it
 *  5. acceptLanguage    — request: adds the `Accept-Language` header
 *  6. formLocales       — request: appends `locale` param (additive, off by default)
 */
export const CORE_INTERCEPTORS: readonly HttpInterceptorFn[] = [
    apiTokenInterceptor,
    apiPrefixInterceptor,
    apiErrorInterceptor,
    apiTokenRefreshInterceptor,
    acceptLanguageInterceptor,
    formLocalesInterceptor,
];
